import { TeleconsultaInterestStateModel } from './../../../domain/models/comercial/teleconsulta-interest-state.model';
import { TeleconsultaInterestStateEntity } from './entities/teleconsulta-interest-state.entity';
import { TeleconsultaInterestStateImplementationRepositoryMapper } from './mappers/teleconsulta-interest-state.mapper';
import { QuotationTaxModel } from '../../../domain/models/comercial/quotation-tax.model';
import { QuotationTaxEntity } from './entities/quotation-tax.entity';
import { mapQuotationTax } from './mappers/quotation-tax.mapper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ComercialRepository } from '../../../domain/repositories/comercial.repository';
import { ComercialImplementationRepositoryMapper } from './mappers/comercial-repository.mapper';
import { ComercialModel } from '../../../domain/models/comercial/comercial.model';
import {
  ComercialEntity,
  DataComercialEntity,
} from './entities/comercial.entity';
import { TypeLicenseImplementationRepositoryMapper } from './mappers/type-license-respository.mapper';
import { TypeLicenseModel } from '../../../domain/models/comercial/type-license.model';
import { FollowupEntity } from './entities/followup.entity';
import { FollowupResponseModel } from '../../../domain/models/comercial/followup-response.model';
import { FollowupResponseEntity } from './entities/followup-response.entity';
import { FollowupImplementationRepositoryMapper } from './mappers/followup-repository.mapper';
import { ValidateFollowupModel } from '../../../domain/models/comercial/validate-followup.model';
import { ValidateFollowupEntity } from './entities/validate-followup.entity';
import { ValidateFollowupImplementationRepositoryMapper } from './mappers/validate-followup-repository.mapper';
import { ProductModel } from '../../../domain/models/comercial/product.model';
import { ProductEntity } from './entities/product.entity';
import { ProductImplementationRepositoryMapper } from './mappers/product-repository.mapper';
import { TeleconsultaInterestInsertImplementationRepositoryMapper } from './mappers/teleconsulta-interest-insert.mapper';
import { TeleconsultaInterestInsertEntity } from './entities/teleconsulta-interest-insert.entity';
import { TeleconsultaInterestInsertModel } from '../../../domain/models/comercial/teleconsulta-interest-insert.model';
import { ComercialPagedModel, ComercialPagedRequestModel } from '../../../domain/models/comercial/comercial-paged.model';
import { ComercialPagedEntity } from './entities/comercial-paged.entity';
import { ComercialPagedImplementationRepositoryMapper } from './mappers/comercial-paged-repository.mapper';
import { ComercialDetailModel } from '../../../domain/models/comercial/comercial-detail.model';
import { FollowupReasonResponseModel } from '../../../domain/models/comercial/followup-reason.model';
import { ComercialDetailEntity } from './entities/comercial-detail.entity';
import { ComercialDetailImplementationRepositoryMapper } from './mappers/comercial-detail-repository.mapper';
import { CommercialConsentPublicResponseModel, CommercialConsentResponseRequestModel, CommercialConsentResultResponseModel, CommercialConsentPrecheckRequestModel, CommercialConsentPrecheckResponseModel } from '../../../domain/models/comercial/commercial-consent.model';
import { ContractualValidityResponseModel } from '../../../domain/models/comercial/contractual-validity.model';
import { AccionElegibleComercialItem, ApiResponse, CatalogoComercialItem, DocumentoComercialItem, OportunidadComercialItem, PlanActivoComercialItem, RelacionComercialItem, RelacionComercialRequest, SeguimientoComercialItem } from '../../../domain/models/comercial/comercial-v1.model';

@Injectable({
  providedIn: 'root',
})
export class ComercialImplementationRepository extends ComercialRepository {
  comercialMapper = new ComercialImplementationRepositoryMapper();
  comercialMapper2 = new ComercialImplementationRepositoryMapper();
  comercialMapper3 = new ComercialImplementationRepositoryMapper();
  comercialMapper4 = new ComercialImplementationRepositoryMapper();
  comercialPagedMapper = new ComercialPagedImplementationRepositoryMapper();
  comercialDetailMapper = new ComercialDetailImplementationRepositoryMapper();
  license = new TypeLicenseImplementationRepositoryMapper();
  followup = new FollowupImplementationRepositoryMapper();
  followup2 = new FollowupImplementationRepositoryMapper();
  followup3 = new ValidateFollowupImplementationRepositoryMapper();
  product = new ProductImplementationRepositoryMapper();
  teleconsultaInterestState = new TeleconsultaInterestStateImplementationRepositoryMapper();
  teleconsultaInterestInsert = new TeleconsultaInterestInsertImplementationRepositoryMapper();
  url = environment.baseUrl;
  constructor(private http: HttpClient) {
    super();
  }

  override insertComercial(
    params: DataComercialEntity
  ): Observable<ComercialModel> {
    return this.http
      .post<ComercialEntity>(`${this.url}/ProspectosCliente/Insert`, params)
      .pipe(map(this.comercialMapper.mapFrom));
  }

  override insertFollowup(
    params: FollowupEntity
  ): Observable<FollowupResponseModel> {
    return this.http
      .post<FollowupResponseEntity>(
        `${this.url}/SeguimientosProspecto/Insert`,
        params
      )
      .pipe(map(this.followup.mapFrom));
  }

  override getComercialAll(params: {
    idEstadoProspecto: string;
    idUsuarioCreacion: string;
  }): Observable<ComercialModel> {
    return this.http
      .post(`${this.url}/ProspectosCliente/GetAllByUserId`, params)
      .pipe(map(this.comercialMapper2.mapFrom));
  }

  override getComercialPaged(params: ComercialPagedRequestModel): Observable<ComercialPagedModel> {
    return this.http
      .post<ComercialPagedEntity>(`${this.url}/ProspectosCliente/GetPaged`, params)
      .pipe(map(this.comercialPagedMapper.mapFrom));
  }

  override getComercialById(params: { id: string }): Observable<ComercialDetailModel> {
    return this.http
      .post<ComercialDetailEntity>(`${this.url}/ProspectosCliente/GetById`, params)
      .pipe(map(this.comercialDetailMapper.mapFrom));
  }

  override getFollowupById(params: {
    id: string;
  }): Observable<FollowupResponseModel> {
    return this.http
      .post<FollowupResponseEntity>(
        `${this.url}/SeguimientosProspecto/GetByIdProspecto`,
        params
      )
      .pipe(map(this.followup2.mapFrom));
  }

  override getFollowupReasons(params: {
    idTipoSeguimientoProspecto: string;
  }): Observable<FollowupReasonResponseModel> {
    return this.http.post<FollowupReasonResponseModel>(
      `${this.url}/SeguimientosProspecto/ListarMotivos`,
      { idTipoSeguimientoProspecto: params.idTipoSeguimientoProspecto }
    );
  }

  override downloadCommercialDocument(params: {
    id: string;
    idSeguimiento: string;
    tipoOrigen: string;
  }): Observable<Blob> {
    return this.http.post(
      `${this.url}/SeguimientosProspecto/DownloadDocument`,
      {
        id: params.id,
        id2: params.idSeguimiento,
        descripcion: params.tipoOrigen,
      },
      { responseType: 'blob' }
    );
  }

  override downloadSignedConsentDocument(params: { id: string }): Observable<Blob> {
    return this.http.post(
      `${this.url}/SeguimientosProspecto/SignedConsentDocument`,
      { id: params.id },
      { responseType: 'blob' }
    );
  }

  override getTypeLicense(params: {
      id: string;
    }): Observable<TypeLicenseModel> {
     return this.http
       .post(`${this.url}/Planes/GetByIdProducto`, params)
       .pipe(map(this.license.mapFrom));
  }

  override getValidateComercialFollowup(params: {
    id: string;
    id2: string;
  }): Observable<ValidateFollowupModel> {
    return this.http
      .post<ValidateFollowupEntity>(
        `${this.url}/SeguimientosProspecto/ValidateProspectByTypeFollowUp`,
        params
      )
      .pipe(map(this.followup3.mapFrom));
  }

  override deleteComercial(params: { Id: string }): Observable<ComercialModel> {
    return this.http
      .delete(`${this.url}/ProspectosCliente/Delete/${params.Id}`)
      .pipe(map(this.comercialMapper3.mapFrom));
  }

  override updateComercial(
    params: DataComercialEntity
  ): Observable<ComercialModel> {
    return this.http
      .put<ComercialEntity>(`${this.url}/ProspectosCliente/Update`, params)
      .pipe(map(this.comercialMapper4.mapFrom));
  }

  override getProduct(): Observable<ProductModel> {
    return this.http
      .get(`${this.url}/SeguimientosProspecto/GetProductos`)
      .pipe(map(this.product.mapFrom));
  }
  override saveQuotationTax(params: QuotationTaxModel): Observable<ApiResponse<QuotationTaxModel>> {
    return this.http.post<ApiResponse<QuotationTaxEntity>>(`${this.url}/SeguimientosProspecto/SaveImpuesto`, params)
      .pipe(map(response => ({ ...response, data: response.data ? mapQuotationTax(response.data) : undefined })));
  }
  override getQuotationTaxes(soloActivos = true): Observable<ApiResponse<QuotationTaxModel[]>> {
    return this.http.get<ApiResponse<QuotationTaxEntity[]>>(`${this.url}/SeguimientosProspecto/GetImpuestos`, { params: { soloActivos } })
      .pipe(map(response => ({ ...response, data: (response.data || []).map(mapQuotationTax) })));
  }
  override getContractualValidities(): Observable<ContractualValidityResponseModel> {
    return this.http.get<ContractualValidityResponseModel>(`${this.url}/SeguimientosProspecto/GetVigenciasContractuales`);
  }
  override getTeleconsultaInterest(params: {
    id: string;
  }): Observable<TeleconsultaInterestStateModel> {
    return this.http
      .get<TeleconsultaInterestStateEntity>(
        `${this.url}/ServiciosEmpresa/GetInterestState/${params.id}`,
      )
      .pipe(map(this.teleconsultaInterestState.mapFrom));
  }

    override insertTeleconsultaInterest(params: {
    id: string;
    descripcion: string;
  }): Observable<TeleconsultaInterestInsertModel> {
    return this.http
      .post<TeleconsultaInterestInsertEntity>(
        `${this.url}/ServiciosEmpresa/InsertInterest`,
        params
      )
      .pipe(map(this.teleconsultaInterestInsert.mapFrom));
  }

  override getCommercialConsent(params: {
    token: string;
  }): Observable<CommercialConsentPublicResponseModel> {

    const headers = new HttpHeaders({
      'No-Auth': 'True'
    });

    return this.http.get<CommercialConsentPublicResponseModel>(
      `${this.url}/ConsentimientoComercial/Get`,
      {
        params: {
          token: params.token
        },
        headers
      }
    );
  }

  override respondCommercialConsent(
    params: CommercialConsentResponseRequestModel
  ): Observable<CommercialConsentResultResponseModel> {

    const headers = new HttpHeaders({
      'No-Auth': 'True'
    });

    return this.http.post<CommercialConsentResultResponseModel>(
      `${this.url}/ConsentimientoComercial/Respond`,
      params,
      {
        headers
      }
    );
  }

  override precheckCommercialConsent(
    params: CommercialConsentPrecheckRequestModel
  ): Observable<CommercialConsentPrecheckResponseModel> {
    return this.http.post<CommercialConsentPrecheckResponseModel>(
      `${this.url}/SeguimientosProspecto/ConsentPrecheck`,
      params
    );
  }

  override getResponsablesEmpresa(): Observable<ApiResponse<CatalogoComercialItem[]>> {
    return this.http.get<ApiResponse<CatalogoComercialItem[]>>(`${this.url}/Usuarios/GetCatalogoByEmpresa`);
  }

  override getRelacionesComercialesPaged(params: RelacionComercialRequest): Observable<ApiResponse<RelacionComercialItem[]>> {
    return this.http.post<ApiResponse<RelacionComercialItem[]>>(`${this.url}/RelacionesComerciales/GetPaged`, params);
  }

  override getTiposUltimoSeguimiento(): Observable<ApiResponse<any[]>> {
    return this.http.get<ApiResponse<any[]>>(`${this.url}/TiposSeguimientoProspecto/GetUltimosSeguimientos`);
  }

  override getRelacionComercialById(params: RelacionComercialRequest): Observable<ApiResponse<RelacionComercialItem>> {
    return this.http.post<ApiResponse<RelacionComercialItem>>(`${this.url}/RelacionesComerciales/GetById`, params);
  }

  override getRelacionDocumentos(params: RelacionComercialRequest): Observable<ApiResponse<DocumentoComercialItem[]>> {
    return this.http.post<ApiResponse<DocumentoComercialItem[]>>(`${this.url}/RelacionesComerciales/GetDocumentos`, params);
  }

  override getAccionesElegibles(params: RelacionComercialRequest): Observable<ApiResponse<AccionElegibleComercialItem[]>> {
    return this.http.post<ApiResponse<AccionElegibleComercialItem[]>>(`${this.url}/RelacionesComerciales/GetAccionesElegibles`, params);
  }

  override getOportunidadesPaged(params: RelacionComercialRequest): Observable<ApiResponse<OportunidadComercialItem[]>> {
    const request: any = { ...params };

    if (params.idRelacion && params.tipoRelacion) {
      request.idProspectoEmpresa =
        params.tipoRelacion === 'EMPRESA'
          ? params.idRelacion
          : null;
      request.idProspectoCliente =
        params.tipoRelacion === 'CLIENTE'
          ? params.idRelacion
          : null;

      delete request.idRelacion;
      delete request.tipoRelacion;
    }

    return this.http.post<ApiResponse<OportunidadComercialItem[]>>(
      `${this.url}/OportunidadesComerciales/GetPaged`,
      request
    );
  }

  override getOportunidadById(params: { id: string }): Observable<ApiResponse<OportunidadComercialItem>> {
    return this.http.post<ApiResponse<OportunidadComercialItem>>(`${this.url}/OportunidadesComerciales/GetById`, params);
  }

  override getTiposOportunidad(): Observable<ApiResponse<CatalogoComercialItem[]>> {
    return this.http.get<ApiResponse<CatalogoComercialItem[]>>(`${this.url}/OportunidadesComerciales/GetTipos`);
  }

  override getEstadosOportunidad(): Observable<ApiResponse<CatalogoComercialItem[]>> {
    return this.http.get<ApiResponse<CatalogoComercialItem[]>>(`${this.url}/OportunidadesComerciales/GetEstados`);
  }

  override getPlanesActivosPaged(params: RelacionComercialRequest): Observable<ApiResponse<PlanActivoComercialItem[]>> {
    return this.http.post<ApiResponse<PlanActivoComercialItem[]>>(`${this.url}/PlanesActivosComerciales/GetPaged`, params);
  }

  override getSeguimientosPaged(params: RelacionComercialRequest): Observable<ApiResponse<SeguimientoComercialItem[]>> {
    return this.http.post<ApiResponse<SeguimientoComercialItem[]>>(`${this.url}/SeguimientosProspecto/GetPaged`, params);
  }

  override getSeguimientoDetalle(params: { id: string }): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.url}/SeguimientosProspecto/GetById`, params);
  }

}
